import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs'
import { environment } from '../../../environments/environment';
import { IRequestOptions } from '../../models/requestOptions';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl = environment.API_URL;

  private _defaultRequestOptions: IRequestOptions = {
	headers: {},
	showAPIError: true
  };

  private _apiOptions: IRequestOptions = {};

  constructor(
    private http: HttpClient
  ) { }

  async get(url: string, options: IRequestOptions = this._defaultRequestOptions): Promise<IApiResponse> {
	this.setOptions(options);
	return firstValueFrom(this.http.get<IApiResponse>(`${this.apiUrl}${url}`, { headers: options?.headers }));
  }

  async post(url: string, data: IHttpData, options: IRequestOptions = this._defaultRequestOptions): Promise<IApiResponse> {
	this.setOptions(options);
    return firstValueFrom(this.http.post<IApiResponse>(`${this.apiUrl}${url}`, data, { headers: options?.headers }));
  }

  async put(url: string, data: IHttpData, options: IRequestOptions = this._defaultRequestOptions): Promise<IApiResponse> {
	this.setOptions(options);
	return firstValueFrom(this.http.put<IApiResponse>(`${this.apiUrl}${url}`, data, { headers: options?.headers }));
  }

  getOptions(): IRequestOptions {
	return this._apiOptions;
  }

  private setOptions(options: IRequestOptions): void {
	this._apiOptions = { ...this._defaultRequestOptions, ...options };
  }

}

interface IHttpData {
  [key: string]: any;
}

interface IApiResponse {
  [key: string]: any;
  data: any;
  error: any;
  message: string;
  statusCode: 200;
}
